import React, { useState } from 'react';
import * as Styled from './billingAddressStyles';
import TextField from '../../common/formSections/textField/textField';
import { useTranslation } from 'react-i18next';
import MultiTypeFields from '../../common/formSections/multiTypeFields/multiTypeFields';
import { updateCreditApplication } from '../../store/action/action';
import { province, provincefr } from '../../constants/fieldData';
import { connect, useDispatch, useSelector } from 'react-redux';
import creditApplication from '../../constants/creditApplication';
import { updateError } from '../../store/action/errorAction';
import errorData from '../../constants/errorData';

const BillingAddress = () => {
  const [translation] = useTranslation();
  const getWebData = useSelector((state) => state.websiteDataReducer.stateData);
  const color = getWebData.appColor;
  const dispatch = useDispatch();
  const getStoreData = useSelector((state) => state.Reducer.stateData);
  const errorStoreData = useSelector((state) => state.ErrorReducer.errorData);
  const language = getWebData.language;

  const multiTypeFieldData = [
    {
      label: translation('City'),
      type: 'text',
      name: 'city',
      required: 'required',
      value: getStoreData?.billingAddress?.city,
    },
    {
      label: translation('Province'),
      type: 'select',
      name: 'province',
      required: 'required',
      value: getStoreData?.billingAddress?.province,
    },
    {
      label: translation('PostalCode'),
      type: 'postalCode',
      name: 'billingAddressPostalCode',
      required: 'required',
      value: getStoreData?.billingAddress?.billingAddressPostalCode,
    },
  ];
  const [emailAddress, setEmailAddress] = useState(
    getStoreData?.billingAddress?.emailAddress
  );
  const [streetAddress, setStreetAddress] = useState(
    getStoreData?.billingAddress?.streetAddress
  );
  const [city, setCity] = useState(getStoreData?.billingAddress?.city);
  const [provinceDropDown, setProvinceDropDown] = useState(
    getStoreData?.billingAddress?.province
  );
  const [billingAddressPostalCode, setBillingAddressPostalCode] = useState(
    getStoreData?.billingAddress?.billingAddressPostalCode
  );
  let creditCopyObject = Object.assign(
    {},
    getStoreData ? getStoreData : creditApplication
  );
  let errorCopyObject = Object.assign(
    {},
    errorStoreData ? errorStoreData : errorData
  );
  const updateFields = (key, value) => {
    creditCopyObject['billingAddress'] = {
      ...creditCopyObject['billingAddress'],
      [key]: value,
    };
    dispatch(updateCreditApplication(creditCopyObject));
  };
  const updateErrorFields = (key, value) => {
    errorCopyObject = {
      ...errorCopyObject,
      [key]: value,
    };
    dispatch(updateError(errorCopyObject));
  };
  const provinceList = language === 'en-US' ? province : provincefr;
  return (
    <>
      <Styled.SubHeader color={color}>
        {translation('ApplicantsBillingAddress')}
      </Styled.SubHeader>

      <TextField
        value={emailAddress}
        label={translation('EmailAddress')}
        name="emailAddress"
        type="email"
        color={color}
        required="required"
        handleTextInput={(name, value) => {
          updateFields(name, value);
          setEmailAddress(value);
        }}
        handleTextError={(name, value) => {
          updateErrorFields(name, value);
        }}
      />
      <TextField
        value={streetAddress}
        label={translation('StreetAddress')}
        name="streetAddress"
        type="text"
        color={color}
        required="required"
        handleTextInput={(name, value) => {
          updateFields(name, value);
          setStreetAddress(value);
        }}
        handleTextError={(name, value) => {
          updateErrorFields(name, value);
        }}
      />
      <MultiTypeFields
        multiTypeFieldData={multiTypeFieldData}
        color={color}
        optionList={provinceList}
        handleMultiType={(name, value) => {
          updateFields(name, value);
          name === 'city'
            ? setCity(value)
            : name === 'province'
            ? setProvinceDropDown(value)
            : setBillingAddressPostalCode(value);
        }}
        handleError={(name, value) => {
          updateErrorFields(name, value);
        }}
      />
    </>
  );
};
const mapStateToProps = (stateData) => {
  return {
    state: stateData,
  };
};

export default connect(mapStateToProps)(BillingAddress);
